<app-page-breadcrumb pageTitle="Videos" />
<div class="grid grid-cols-1 gap-5 sm:gap-6 xl:grid-cols-2">
  <div class="space-y-5 sm:space-y-6">
    <div>
      <app-component-card title="Video Ratio 16:9">
        <app-sixteen-isto-nine />
      </app-component-card>
    </div>
    
    <div>
      <app-component-card title="Video Ratio 4:3">
        <app-four-isto-three />
      </app-component-card>
    </div>
  </div>

  <div class="space-y-5 sm:space-y-6">
    <div>
      <app-component-card title="Video Ratio 21:9">
        <app-twentyone-isto-nine />
      </app-component-card>
    </div>

    <div>
      <app-component-card title="Video Ratio 1:1">
        <app-one-isto-one />
      </app-component-card>
    </div>
  </div>
</div>